module.exports = __webpack_public_path__ + "static/media/rocket.b79eb783.png";